export const getWidthHeightSize = (sharedData, printProperties) => {
  const tempSharedData = {...sharedData}
  const tempPrintProperties = [...printProperties]
  // const
  // if (temp.size === 'A4') {
  //   return printProperties.filter(v => v.title === sharedData.size)
  // }
//   tempPrintProperties.forEach((rowSizeData, index) => {
//     if (tempSharedData.data.size === rowSizeData.title) {
//       tempSharedData.size = rowSizeData
//     }
//
// debugger
//   })
//
//   return tempSharedData;

  let temp = tempPrintProperties.filter((v, index) => {

    return v.title === tempSharedData.data.sizeTitle
  })

  temp = temp[0]
  console.log(temp)
  return temp
}